import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CoreModule } from '@app/core';
import { OnboardingState } from '@app/core/states/onboarding.state';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { StepperComponent } from '@app/core/stepper/stepper.component';
import { UiModule } from '@app/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { NgxEditorModule } from 'ngx-editor';

import { AddNewPageComponent } from './components/add-new-page/add-new-page.component';
import { AlarmConfigurationComponent } from './components/alarm-configuration/alarm-configuration.component';
import { AppConfigurationShellComponent } from './components/app-configuration-shell/app-configuration-shell.component';
import { AudioDedicationsConfigurationComponent } from './components/audio-dedications-configuration/audio-dedications-configuration.component';
import { BackgroundColorSettingsComponent } from './components/background-color-settings/background-color-settings.component';
import { ButtonStyleSettingsComponent } from './components/button-style-settings/button-style-settings.component';
import { DivRadiusSettingsComponent } from './components/div-radius-settings/div-radius-settings.component';
import { DivShadowSettingsComponent } from './components/div-shadow-settings/div-shadow-settings.component';
import { FontFamilySelectorComponent } from './components/font-family-selector/font-family-selector.component';
import { FontSizeSelectorComponent } from './components/font-size-selector/font-size-selector.component';
import { GeneralConfigurationComponent } from './components/general-configuration/general-configuration.component';
import { HtmlPageConfigurationComponent } from './components/html-page-configuration/html-page-configuration.component';
import { IconStyleSelectorComponent } from './components/icon-style-selector/icon-style-selector.component';
import { MarginSettingsComponent } from './components/margin-settings/margin-settings.component';
import { MenuConfigurationShellComponent } from './components/menu-configuration/menu-configuration-shell/menu-configuration-shell.component';
import { MenuContentComponent } from './components/menu-configuration/menu-content/menu-content.component';
import { MenuDesignComponent } from './components/menu-configuration/menu-design/menu-design.component';
import { OtherPagesConfigurationComponent } from './components/other-pages-configuration/other-pages-configuration.component';
import { PagesListComponent } from './components/pages-list/pages-list.component';
import { SongHistoryConfigurationComponent } from './components/song-history-configuration/song-history-configuration.component';
import { AddNewStreamComponent } from './components/player-configuration/add-new-stream/add-new-stream.component';
import { PlayerButtonsComponent } from './components/player-configuration/player-buttons/player-buttons.component';
import { PlayerConfigurationShellComponent } from './components/player-configuration/player-configuration-shell/player-configuration-shell.component';
import { PlayerContentComponent } from './components/player-configuration/player-content/player-content.component';
import { PlayerDesignComponent } from './components/player-configuration/player-design/player-design.component';
import { StreamListComponent } from './components/player-configuration/stream-list/stream-list.component';
import { StreamListItemComponent } from './components/player-configuration/stream-list-item/stream-list-item.component';
import { StreamEditModalComponent } from './components/player-configuration/stream-edit-modal/stream-edit-modal.component';
import { StreamDeleteDialogComponent } from './components/player-configuration/stream-delete-dialog/stream-delete-dialog.component';
import { StreamSortDialogComponent } from './components/player-configuration/stream-sort-dialog/stream-sort-dialog.component';
import { AddPodcastButtonComponent } from './components/podcast-configuration/add-podcast-button/add-podcast-button.component';
import { PodcastCardComponent } from './components/podcast-configuration/podcast-card/podcast-card.component';
import { PodcastConfigurationComponent } from './components/podcast-configuration/podcast-configuration.component';
import { SettingsCategoryListComponent } from './components/settings-category-list/settings-category-list.component';
import { SimulatorComponent } from './components/simulator/simulator.component';
import { TextAlignSettingsComponent } from './components/text-align-settings/text-align-settings.component';
import { AppConfigurationState } from './states/app-configuration.state';

@NgModule({
  declarations: [
    SimulatorComponent,
    GeneralConfigurationComponent,
    AppConfigurationShellComponent,
    SettingsCategoryListComponent,
    PagesListComponent,
    AddNewPageComponent,
    MenuContentComponent,
    MenuConfigurationShellComponent,
    MenuDesignComponent,
    PlayerConfigurationShellComponent,
    PlayerContentComponent,
    PlayerDesignComponent,
    StreamListComponent,
    StreamListItemComponent,
    StreamEditModalComponent,
    StreamDeleteDialogComponent,
    StreamSortDialogComponent,
    AddNewStreamComponent,
    PlayerButtonsComponent,
    AlarmConfigurationComponent,
    AudioDedicationsConfigurationComponent,
    OtherPagesConfigurationComponent,
    HtmlPageConfigurationComponent,
    BackgroundColorSettingsComponent,
    IconStyleSelectorComponent,
    DivRadiusSettingsComponent,
    TextAlignSettingsComponent,
    ButtonStyleSettingsComponent,
    MarginSettingsComponent,
    DivShadowSettingsComponent,
    FontSizeSelectorComponent,
    FontFamilySelectorComponent,
    AppConfigurationShellComponent,
    PodcastConfigurationComponent,
    PodcastCardComponent,
    AddPodcastButtonComponent,
    SongHistoryConfigurationComponent,
  ],
  imports: [
    FontAwesomeModule,
    NgxEditorModule,
    TranslateModule,
    UiModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatMenuModule,
    MatButtonToggleModule,
    StepperComponent,
    CoreModule,
    DragDropModule,
    NgOptimizedImage,
    FormsModule,
    CommonModule,
    MatProgressSpinnerModule,
    NgxsModule.forFeature([AppConfigurationState, ResponsiveState, OnboardingState]),
  ],
  exports: [AppConfigurationShellComponent],
})
export class AppConfigurationModule {}
